// Vanilla JS jQuery.parents() realisation
//========================================

Element.prototype.parents = function(selector) {
    let elements = [],
        elem = this,
        isHaveSelector = selector !== undefined;

    while ((elem = elem.parentElement) !== null) {
        if (elem.nodeType !== Node.ELEMENT_NODE)
            continue;

        if (!isHaveSelector || elem.matches(selector))
            elements.push(elem);
    }

    return elements;
};

// See if DOM is already available
//================================

window.domReady = (fn) => {
    if (document.readyState === "complete" || document.readyState === "interactive")
        setTimeout(fn, 1);
    else
        document.addEventListener("DOMContentLoaded", fn);
}

// Check for WebP format support with fallback class
//==================================================

(function () {
    'use strict';

    let webp = new Image();
    webp.onerror = () => {
        document.body.classList.add('WebP-fallback');
    };

    webp.src = 'data:image/webp;base64,UklGRjIAAABXRUJQVlA4ICYAAACyAgCdASoBAAEALmk0mk0iIiIiIgBoSygABc6zbAAA/v56QAAAAA==';
})();

// Convert data object to query string
//====================================

window.dataToQueryString = function (data, processValueArray = false) {
    return Object.keys(data).map(key => {
        if(Array.isArray(data[key]) && processValueArray) {
            return data[key].map(arrayValue => {
                return `${encodeURIComponent(key + '[]')}=${encodeURIComponent(arrayValue)}`;
            }).join('&');
        } else return `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`;
    }).join('&');
}

// Add parameters to provided url
//===============================

window.URL_add_parameter = function (url, param, value) {
    let hash = {};
    let parser = document.createElement('a');

    parser.href = url;

    let parameters = parser.search.split(/\?|&/);

    for (let i = 0; i < parameters.length; i++) {
        if (!parameters[i])
            continue;

        let ary = parameters[i].split('=');
        hash[ary[0]] = ary[1];
    }

    hash[param] = value;

    let list = [];
    Object.keys(hash).forEach(function (key) {
        list.push(key + '=' + hash[key]);
    });

    parser.search = '?' + list.join('&');
    return parser.href;
}

// Helper functions for price values
//==================================

window.parseCena = function (text) {
    return text ? parseFloat(text.replace(/\s/g, '')) : '';
};

window.formatCena = function (number) {
    let regex = /(\d+)(\d{3})/;

    number = number.toString();
    while (regex.test(number))
        number = number.replace(regex, '$1 $2');

    return number;
};

window.formatCenaInInput = function (selector, povolitZnaky, zapornaCisla) {
    let element = document.querySelector(selector);
    if(typeof(element) === 'undefined' || element === null)
        return;

    element.addEventListener('keyup', () => {
        if(typeof povolitZnaky !== undefined && (povolitZnaky && isNaN(element.value.replace(' ', '').replace('.', ','))))
            return;

        let reg = /[^0-9 ]/;
        if (zapornaCisla)
            reg = /[^0-9 \-]/;

        let number = element.value.replace(reg, ''); // odstranime znaky, pokud to nejsou cisla nebo mezera
        if (number === '')
            return;

        element.value = formatCena(parseCena(number));
        element.style.textAlign = 'right';
    });

    if (element.value !== '' && typeof povolitZnaky == 'undefined')
        element.value = formatCena(parseCena(element.value));
};
